import { Sites } from '@ps/platform-message-framework/common/Sites';
import { applyPatch } from 'fast-json-patch';
import type { Operation } from 'fast-json-patch';
import { produce } from 'immer';
import { takeUntil } from 'rxjs/operators';

import { subscribe } from '@swf/core/api/subscribe';
import type { EffectParams, ModelConfig, Slicer } from '@swf/core/store';
import { logout } from '@swf/core/utils/actions';

import type { SpinOfDayData } from '../types/CasinoBonus';

export interface SotDGameState {
  data?: Record<string, SpinOfDayData>;
}

interface SotDModel extends ModelConfig<SotDGameState> {
  reducers: typeof reducers;
  selectors: typeof selectors;
  effects: typeof effects;
}

const defaultState = {};

const reducers = {
  set: (state: SotDGameState, payload: SotDGameState) => ({
    ...state,
    ...payload
  }),
  patch: (state: SotDGameState, { body }: { body: { spinOfTheDay: Operation[] } }) =>
    produce(state, (draft = {}) => {
      draft.data = draft.data || {};

      if (body?.spinOfTheDay?.length === 0) {
        draft.data = {};
      } else {
        applyPatch(draft.data, body.spinOfTheDay);
      }
      return draft;
    })
};

const selectors = (slice: Slicer<SotDGameState>) => ({
  getData() {
    return slice((state) => state.data);
  },
  isLoading() {
    return slice((state) => !state.data);
  }
});

const effects = {
  async fetch(payload: undefined, params: EffectParams) {
    const { actions, dispatch, rootState, select } = params;
    const clientAuthenticated = select.session.isClientAuthenticated(rootState);

    if (!clientAuthenticated) {
      dispatch.spinOfTheDay.set(defaultState);
      return;
    }

    const onLogout = logout(actions) as NonNullable<ReturnType<typeof logout>>;
    subscribe('/user/queue/casino/snapshotupdate')
      .pipe(takeUntil(onLogout))
      .subscribe(dispatch.spinOfTheDay.patch);
    select.cms.getSiteId(rootState) === Sites.UK && (await dispatch.casino.fetchPrizeGameVersion());
  }
};

const model: SotDModel = {
  state: defaultState,
  reducers,
  selectors,
  effects
};

export default model;
